<div class="container-fluid py-2 py-md-3 px-0">
  <app-event-form
    title="Crea evento"
    submitLabel="Crea"
    [availableOrganizations]="availableOrganizations()"
    (formSubmit)="onSubmit($event)"
    (cancel)="onCancel()">
  </app-event-form>
</div>

